import * as actionTypes from "../actionTypes/actionTypes";
import {
  getDiscountService,
  createDiscountService,
  updateDiscountService,
  deleteDiscountService,
  getTransactionTypeService
  } from "../services/DiscountService";
import * as _ from "lodash";
const getDiscounts = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_DISCOUNTS
        })
        window.startLoading();
        getDiscountService()
        .then((response)=>{
          const data = response.data;
          const sortedDiscounts = _.sortBy(data, ['discountLabel']);
            dispatch({
                type: actionTypes.GET_DISCOUNTS_SUCCESS,
                payload: sortedDiscounts
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_DISCOUNTS_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}


const createDiscount = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_CURRENCY,
    });
    window.startLoading();
    await createDiscountService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_CURRENCY_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_CURRENCY_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      })
  };
};

const updateDiscount = (discountId, requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CURRENCY,
    });
    window.startLoading();
    await updateDiscountService(discountId, requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.UPDATE_CURRENCY_SUCCESS,
          payload: data,
          discountId: discountId
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_CURRENCY_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const deleteDiscount = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_CURRENCY
      })
      window.startLoading();
      await deleteDiscountService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_CURRENCY_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_CURRENCY_FAILURE,
              payload: error
          })
      }).finally(()=>{
        window.stopLoading();
      });
  }
}

const getDiscountsListData = (discountListData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.RENDER_DISCOUNT_LIST_DATA,
      payload:discountListData
    })
  }
}

const getTransactionTypes = () => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.GET_TRANSACTION_TYPE
    })
    window.startLoading();
    getTransactionTypeService()
    .then((response) => {
      const data = response.data
      dispatch({
        type: actionTypes.GET_TRANSACTION_TYPE_SUCCESS,
        payload: data
      })
    }).catch((error) => {
      dispatch({
        type: actionTypes.GET_TRANSACTION_TYPE_FAILURE,
        payload: error
      })
    }).finally(()=>{
      window.stopLoading();
    });
  }
}

export { getDiscounts, createDiscount, updateDiscount, deleteDiscount, getDiscountsListData, getTransactionTypes };
